import { CoreTooltip } from '@featuring-corp/components';
import { IconChatOutline, IconFavoriteOutline } from '@featuring-corp/icons';
import { disabledAnchor } from '@styles/vanilla-extract/utils';
import React from 'react';

import round from '@utils/round';

import CoreImg from '@shared/CoreImg';

import {
	TagClass,
	containerClass,
	engagementClass,
	hashTagClass,
	hashTagDescClass,
	imgContainerClass,
	imgContentClass,
	textClass,
	textContainerClass,
	textHeaderClass,
} from './style.css';
import { Link } from 'react-router-dom';
import CustomLink from 'src/shared/custom-link/CustomLink';

export interface PopularContentItemProps {
	outLink?: string;
	imgSrc?: string;
	hashTag?: string;
	likeCount?: number;
	commentCount?: number;
	idx?: number;
	isLikeHidden?: boolean;
	isCommentHidden?: boolean;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const PopularContentItem = ({
	idx = 0,
	isLoading,
	isError,
	lackOfPermission,
	...props
}: PopularContentItemProps) => {
	const available = !isLoading && !isError && !lackOfPermission;
	const outLink = !available ? '' : props.outLink;
	const imgSrc = isError
		? 'public/images/report/no-image.png'
		: lackOfPermission
		? `https://source.unsplash.com/random?${idx}`
		: props.imgSrc;

	const likeCount =
		isLoading || isError
			? '-'
			: lackOfPermission
			? '00'
			: props.likeCount?.toString()
			? round(props.likeCount, 'down')
			: '-';
	const commentCount =
		isLoading || isError
			? '-'
			: lackOfPermission
			? '00'
			: props.commentCount?.toString()
			? round(props.commentCount, 'down')
			: '-';
	const hashTag =
		isLoading || isError ? '#-' : lackOfPermission ? '#example' : props.hashTag ?? '#-';

	return (
		<CustomLink
			href={outLink ?? ''}
			target={'_blank'}
			className={disabledAnchor}
			aria-disabled={!available}
		>
			<div className={containerClass}>
				<div className={imgContainerClass}>
					<div className={imgContentClass}>
						<CoreImg
							src={imgSrc ?? ''}
							alt="feed-content-image"
							is_loading={isLoading}
							object_fit="cover"
						/>
					</div>
					<div className={TagClass}>{'⭐️ 인기 콘텐츠'}</div>
				</div>

				<div className={textContainerClass}>
					<div className={textHeaderClass}>
						<p className={hashTagClass}>{hashTag}</p>
						<p className={hashTagDescClass}>{'해시태그 기준'}</p>
					</div>

					<div className={engagementClass}>
						<CoreTooltip
							disabled={!props.isLikeHidden}
							text={
								"계정 사용자가 게시물의 '좋아요' 수를 숨김 처리하여 숫자가 비공개 상태입니다."
							}
							autoAdjust
						>
							<div className={textClass({ isPrivate: props.isLikeHidden })}>
								<IconFavoriteOutline />
								{props.isLikeHidden ? '비공개' : `${likeCount} 개`}
							</div>
						</CoreTooltip>

						<CoreTooltip
							disabled={!props.isCommentHidden}
							text={
								'계정 사용자가 게시물의 댓글 기능을 비활성화하여 숫자가 비공개 상태입니다.'
							}
							autoAdjust
						>
							<div className={textClass({ isPrivate: props.isCommentHidden })}>
								<IconChatOutline />
								{props.isCommentHidden ? '비활성화' : `${commentCount} 개`}
							</div>
						</CoreTooltip>
					</div>
				</div>
			</div>
		</CustomLink>
	);
};

export default PopularContentItem;
